import { useRCAMainStyles } from "../../../RCA.styles";
import { RCASettingsEntity } from "entities/RCA/RCASettingsEntity/RCASettingsEntity";
import RCASettingsAccordion from "../../component/RCASettingsAccordion";
import useRolesPermissions from "hooks/useRolesPermissions";
import { useMemo } from "react";
import { USERTYPE } from "constants/constants";

export const RCATriggersSetting = () => {
    const mainClasses = useRCAMainStyles();
    const { RCA_PERMISSIONS } = useRolesPermissions();
    const userTypes = Object.values(USERTYPE).filter((typeId) => {
        return typeId !== USERTYPE.OSORNOADMINISTRATOR || typeId !== USERTYPE.OPERATOR;
    });
    const { rcaSettings, apolloQueryError, loading, refetch } = RCASettingsEntity.GetRCASettings(userTypes);
    const userCanEdit = useMemo(() => RCA_PERMISSIONS?.settings?.canEdit, [RCA_PERMISSIONS]);

    return (
        <div>
            <div style={{ padding: 0 }} className={mainClasses.contentWrapper}>
                {rcaSettings.map((rcaSetting, index) => (
                    <RCASettingsAccordion
                        refetch={refetch}
                        key={rcaSetting.production_line_id}
                        defaultExpanded={index === 0}
                        loading={loading}
                        apolloQueryError={apolloQueryError}
                        rcaSetting={rcaSetting}
                        canEdit={userCanEdit}
                    />
                ))}
            </div>
        </div>
    );
};
